export default {"src":"/planos/_next/static/media/equifax-report-money.50f55158.svg","height":50,"width":38,"blurWidth":0,"blurHeight":0};